import { Renderer } from 'marked';

export class MarkedRenderer extends Renderer { }
